import React, { useEffect } from 'react';

const Toast = ({ toast, hideToast, message, type = 'success', onClose = () => {}, duration = 3000 }) => {
  // Support both old API (message, type, onClose) and new API (toast object)
  const toastData = toast || (message ? { message, type, duration } : null);
  const toastMessage = toastData?.message;
  const toastType = toastData?.type || type;
  const toastDuration = toastData?.duration || duration;
  const handleClose = hideToast || onClose;

  // Safe wrapper function
  const safeClose = () => {
    if (typeof handleClose === 'function') {
      handleClose();
    }
  };

  useEffect(() => {
    if (toastDuration > 0 && toastMessage && typeof handleClose === 'function') {
      const timer = setTimeout(() => {
        if (typeof handleClose === 'function') {
          handleClose();
        }
      }, toastDuration);
      return () => clearTimeout(timer);
    }
  }, [toastDuration, toastMessage, handleClose]);

  // Don't render if no message
  if (!toastMessage) {
    return null;
  }

  const bgColor = toastType === 'success' ? 'bg-green-500' : toastType === 'error' ? 'bg-red-500' : 'bg-blue-500';

  return (
    <div className="fixed top-4 right-4 z-50 animate-slide-in">
      <div className={`${bgColor} text-white px-6 py-3 rounded-lg shadow-lg flex items-center gap-3 min-w-[300px]`}>
        <span className="text-xl">{toastType === 'success' ? '✓' : toastType === 'error' ? '✕' : 'ℹ'}</span>
        <span className="flex-1">{toastMessage}</span>
        <button
          onClick={safeClose}
          className="text-white hover:text-gray-200 font-bold text-xl leading-none"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default Toast;

